export default __webpack_public_path__ + "static/media/logo.5cbfbe77.png";